import uniqid from "uniqid";

import GitHubIcon from "@mui/icons-material/GitHub";
import LaunchIcon from "@mui/icons-material/Launch";

import Reveal from "../Reveal/Reveal";
import "./projectContainer.css";

const ProjectContainer = ({ project, index = 0 }) => (
  <Reveal as="li" className="project-reveal" delay={index * 90}>
   <div className="project">
    <h3 className="heading-text">{project.name}</h3>

    <p className="project__description">{project.description}</p>
    {project.stack && (
      <ul className="project__stack">
        {project.stack.map((item) => (
          <li key={uniqid()} className="project__stack-item">
            {item}
          </li>
        ))}
      </ul>
    )}

    {project.sourceCode && (
      <a
        href={project.sourceCode}
        aria-label="source code"
        className="link link--icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <GitHubIcon />
      </a>
    )}

    {project.livePreview && (
      <a
        href={project.livePreview}
        aria-label="live preview"
        className="link link--icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <LaunchIcon />
      </a>
    )}
   </div>
  </Reveal>
);

export default ProjectContainer;
